export default { log: console.log, error: console.error };